<div class="wrap">
  <div [ngClass]="{club : index%2 == 0, club_blue: index%2 != 0 }">
    <div class="club_content">
      <h4>{{club.nom}}</h4>
      <div class="type_adresse">
        {{club.adresse}}<br>
        CP {{club.codE_POSTAL}} <span *ngIf="dist">- {{dist}}km</span></div>
      <div class="hours" *ngIf="club.horaires"><span>Heures d'ouvertures:</span><br>{{club.horaires}}</div>
    </div>
    <div class="contact">
      <div class="web" *ngIf="club.url">
        <a [href]="club.url">
          <fa-icon [icon]="faGlobe"></fa-icon>
        </a>
      </div>
      <div class="phone_mail">
        <a href="tel:0033{{club.telephone}}" class="phone">
          <fa-icon [icon]="faPhone"></fa-icon>
        </a>
        <a href="mailto:{{club.email}}" class="phone">
          <fa-icon [icon]="faEnvelope"></fa-icon>
        </a>
      </div>
    </div>
  </div>
</div>